export const reportCancel = (error, url) => {
  const cancelResponse = {
    endpoint: url,
    message: "Cancelled",
    error: false,
    data: null,
    status: null,
    response: error,
    timestamp: new Date().toISOString(),
  };

  if (process.env.NODE_ENV !== "production") {
    console.warn("Request Canceled: ", cancelResponse);
  }

  return cancelResponse;
};
